import { routes } from './routes/index'
import baseStore from './store/index'
import { initVueConfig } from '@commons/config'

document.addEventListener('DOMContentLoaded', () => {
  const Vue = initVueConfig(routes, baseStore)
  Vue.$mount('#manage-app')
})